type Props = {
  /** Newest first: the bars narrow downward under a down arrow. */
  descending: boolean;
  width?: string;
  height?: string;
};

/**
 * The sort-order glyph for a date toggle: an arrow beside three bars that
 * narrow in the direction the list runs, so the icon itself shows the current
 * order. Square 24 grid, stroked in `currentColor`. Replaces `SortIcon`, a
 * 25×26 filled glyph whose default fill was gold.
 */
const SortOrderIcon = ({ descending, width = '16', height = '16' }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {descending ? (
      <>
        <path d="m3 16 4 4 4-4" />
        <path d="M7 20V4" />
        <path d="M11 4h10" />
        <path d="M11 8h7" />
        <path d="M11 12h4" />
      </>
    ) : (
      <>
        <path d="m3 8 4-4 4 4" />
        <path d="M7 4v16" />
        <path d="M11 12h4" />
        <path d="M11 16h7" />
        <path d="M11 20h10" />
      </>
    )}
  </svg>
);

export default SortOrderIcon;
